export default __webpack_public_path__ + "static/media/DEIcon.3f5736e0.svg";